<template>
  <v-main class="pa-0">
    <v-card>
      <v-card-title>
        General Courtesy
      </v-card-title>
      <v-card-text style="white-space: nowrap" v-if="profileAddEdit && profileAddEdit.rules">
        <v-row>
          <v-col cols="12">
            <v-toolbar-title><v-icon>mdi-arrow-right-bold-circle</v-icon> Minimum # Hands</v-toolbar-title>
          </v-col>
          <v-col cols="12" class="d-flex align-center">
            <v-icon small>mdi-checkbox-blank-circle</v-icon>
            <span class="mx-5">between</span>
            <v-text-field outlined hide-details type="number" v-model="profileAddEdit.rules.minimum_hands.min_hand"></v-text-field>
            <span class="mx-5">and</span>
            <v-text-field outlined hide-details type="number" v-model="profileAddEdit.rules.minimum_hands.max_hand"></v-text-field>
            <span class="mx-5">hands, stdev =</span>
            <v-text-field outlined hide-details v-model="profileAddEdit.rules.minimum_hands.stdev"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-toolbar-title><v-icon>mdi-arrow-right-bold-circle</v-icon> Hands To Wait After Warning</v-toolbar-title>
          </v-col>
          <v-col cols="12" class="d-flex align-center">
            <v-icon small>mdi-checkbox-blank-circle</v-icon>
            <span class="mx-5">between</span>
            <v-text-field outlined hide-details type="number" v-model="profileAddEdit.rules.hands_wait_after_warning.min_hand"></v-text-field>
            <span class="mx-5">and</span>
            <v-text-field outlined hide-details type="number" v-model="profileAddEdit.rules.hands_wait_after_warning.max_hand"></v-text-field>
            <span class="mx-5">hands, stdev =</span>
            <v-text-field outlined hide-details v-model="profileAddEdit.rules.hands_wait_after_warning.stdev"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-toolbar-title><v-icon>mdi-arrow-right-bold-circle</v-icon> Initial Warning <v-btn class="ml-5" color="green" icon @click="addWarnElseIf"><v-icon>mdi-plus</v-icon></v-btn></v-toolbar-title>
          </v-col>
          <v-col cols="12" class="d-flex align-center">
            <v-icon small>mdi-checkbox-blank-circle</v-icon>
            <span class="mx-5">If result is >=</span>
            <v-text-field outlined hide-details type="number" v-model="profileAddEdit.rules.initial_warning.result_gte_bb"></v-text-field>
            <span class="mx-5">bb... give warning</span>
            <v-text-field outlined hide-details type="number" v-model="profileAddEdit.rules.initial_warning.pct_of_time"></v-text-field>
            <span class="ml-5">% of the time</span>
          </v-col>

          <v-col cols="12" class="d-flex align-center" v-for="(r, i) of profileAddEdit.rules.initial_warning.elseif" :key="'warn-' + i">
            <v-icon small color="red" @click="popFromArr(profileAddEdit.rules.initial_warning.elseif, i)">mdi-delete</v-icon>
            <span class="mx-5">Else if result is >=</span>
            <v-text-field outlined hide-details type="number" v-model="r.result_gte_bb"></v-text-field>
            <span class="mx-5">bb... give warning</span>
            <v-text-field outlined hide-details type="number" v-model="r.pct_of_time"></v-text-field>
            <span class="ml-5">% of the time</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-toolbar-title><v-icon>mdi-arrow-right-bold-circle</v-icon> Re-warning <v-btn class="ml-5" color="green" icon @click="addRewarnElseIf"><v-icon>mdi-plus</v-icon></v-btn></v-toolbar-title>
          </v-col>
          <v-col cols="12" class="d-flex align-center">
            <v-icon small>mdi-checkbox-blank-circle</v-icon>
            <span class="mx-5">If win another >=</span>
            <v-text-field outlined hide-details type="number" v-model="profileAddEdit.rules.re_warning.win_another_gte_bb"></v-text-field>
            <span class="mx-5">bb... warn again</span>
            <v-text-field outlined hide-details type="number" v-model="profileAddEdit.rules.re_warning.pct_of_time"></v-text-field>
            <span class="ml-5">% of the time</span>
          </v-col>

          <v-col cols="12" class="d-flex align-center" v-for="(r, i) of profileAddEdit.rules.re_warning.elseif" :key="'rewarn-' + i">
            <v-icon small color="red" @click="popFromArr(profileAddEdit.rules.re_warning.elseif, i)">mdi-delete</v-icon>
            <span class="mx-5">Else if win another >=</span>
            <v-text-field outlined hide-details type="number" v-model="r.win_another_gte_bb"></v-text-field>
            <span class="mx-5">bb... warn again</span>
            <v-text-field outlined hide-details type="number" v-model="r.pct_of_time"></v-text-field>
            <span class="ml-5">% of the time</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" block @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

  </v-main>
</template>

<script>
export default {
  name: "GeneralCourtesyProfile",
  data() {
    return {
      askAdd: false,

      rewarnElseIf: [],
      warnElseIf: [],

      rewarnTemplate: {
        "win_another_gte_bb": 0,
        "pct_of_time": 100,
      },
      warnTemplate: {
        "result_gte_bb": 0,
        "pct_of_time": 100,
      },

      profiles: [],

      profileTemplate: {
        name: "general_courtesy",
        rules: {
          minimum_hands: {
            min_hand: 0,
            max_hand: 0,
            stdev: ""
          },
          hands_wait_after_warning: {
            min_hand: 0,
            max_hand: 0,
            stdev: ""
          },
          initial_warning: {
            result_gte_bb: 0,
            pct_of_time: 100,
            elseif: [

            ]
          },
          re_warning: {
            win_another_gte_bb: 0,
            pct_of_time: 100,
            elseif: [

            ]
          }
        }
      },

      profileAddEdit: {},
    }
  },

  mounted() {
    this.loadProfile()
  },

  methods: {
    loadProfile() {
      this.$axios.get("/api/profiles?name=general_courtesy").then((res) => {
        const data = res.data;
        this.profileAddEdit = data.profile;

        if (!data.success) {
          this.profileAddEdit = {...this.profileTemplate};
        }

        if (!("hands_wait_after_warning" in this.profileAddEdit.rules)) {
          this.profileAddEdit.rules.hands_wait_after_warning = {
            min_hand: 0,
            max_hand: 0,
            stdev: ""
          }
        }
      }).catch((err) => {
        console.error(err);
        this.profileAddEdit = {...this.profileTemplate};
      })
    },

    addRewarnElseIf() {
      this.profileAddEdit.rules.re_warning.elseif.push({...this.rewarnTemplate});
    },

    addWarnElseIf() {
      this.profileAddEdit.rules.initial_warning.elseif.push({...this.warnTemplate});
    },

    popFromArr(arr, index) {
      arr.splice(index, 1);
    },

    save() {
      const payload = {...this.profileAddEdit};

      this.$axios.post("/api/profiles", payload).then(() => {
        console.log("updated profile");
      }).catch((err) => {
        console.error(err);
      })
    }
  }
}
</script>

<style scoped>

</style>
